<template>
  <!-- 유지보수상세 내역 -->
  <div class="columns is-multiline">
    <div class="column is-6">
      <div class="box">
        <admin-box-item title="주문정보">
          <admin-form-item label="주문번호"></admin-form-item>
          <admin-form-item label="신청일자"></admin-form-item>
          <admin-form-item label="서비스명"></admin-form-item>
        </admin-box-item>
      </div>
    </div>
    <div class="column is-6">
      <div class="box">
        <admin-box-item title="담당자 정보">
          <admin-form-item label="담당자명"></admin-form-item>
          <admin-form-item label="주문일자"></admin-form-item>
          <admin-form-item label="주문명"></admin-form-item>
        </admin-box-item>
      </div>
    </div>
    <div class="column is-full">
      <div class="box">
        <admin-box-item title="주문품목 정보">
          <admin-form-item label="결제상품">

          </admin-form-item>
        </admin-box-item>
      </div>
    </div>
    <!--<div class="column is-full">
      <div class="box" v-if="$route.query.id">
        <admin-box-item title="1:1 문의 답변 등록">
          <div class="columns is-multiline">
            <div class="column is-full">
              &lt;!&ndash; 댓글 &ndash;&gt;
              <admin-form-item label="댓글 목록">
                <div class="comment-list-box" v-if="comment_list.length>0">
                  <div v-for="(item, idx) in comment_list"
                       :key="'comments'+idx"
                       :class="{'comment-align-right': item.author_type==='user'}"
                       style="margin-bottom:12px">
                    <div>
                      <div class="flex-align" style="font-size:11px">
                        <div :class="{'primary-display-name':item.author_type==='admin'}"
                             v-if="!item.is_internal_comment">{{ item.display_name }}</div>
                        <div v-else style="color:#2196f3">내부 메모</div>
                        <div style="margin-left: 12px">{{ item.created_time }}</div>
                        <div @click="deleteComment(item)"
                             class="unselect"
                             style="padding-left: 10px;">삭제</div>
                      </div>
                      <div :class="{'flex-end':item.author_type==='user'}">
                        <div class="comment-div" :class="{'flex-end':item.author_type==='user'}">{{ item.content }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else>댓글이 없습니다.</div>
              </admin-form-item>

              <admin-form-item label="댓글 작성">
                <div style="margin-bottom: 10px;">
                    <span class="select">
                      <select v-model="comments.is_internal_comment"
                              @change="selectInternalComment">
                        <option :value="false" selected>기본</option>
                        <option :value="true">내부 메모</option>
                      </select>
                    </span>
                </div>
                <div class="flex">
                  <div style="margin-right:12px;width:90%">
                    <textarea class="textarea" v-model="comments.content"></textarea>
                  </div>
                  <div>
                    <button class="button is-primary"
                            style="height: 100% !important"
                            @click="regComment">등록
                    </button>
                  </div>
                </div>
              </admin-form-item>
            </div>
          </div>
        </admin-box-item>
      </div>
    </div>-->
  </div>
</template>
<script>
  export default {
    name: "ManagementFeeSubtractDetail",
    data() {
      return {
        order: undefined
      }
    },
    created() {
      this.getDetail();
    },
    methods: {
      getDetail() {
        this.$axios.get(`launchpack/admin/order/${this.$route.query.id}`).then(res => {
          this.order = res.data;
        })
      }
    }
  }
</script>
<style lang="stylus" scoped>
</style>
